module.exports = __webpack_public_path__ + "img/btc.8d740203.svg";